<template>
    <div class="card" v-if="loadForm" v-loading="loading_submit">
        <Keypress key-event="keyup"
                  @success="checkKey"/>
        <Keypress key-event="keyup" :multiple-keys="multiple" @success="checkKeyWithAlt"/>
        <div class="card-header bg-info" style="height: 50px; display: flex; align-items: center">
            <div style="font-size: 16px; color: #fff">{{ title }}</div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-9 col-12">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-8">
                                    <x-select v-model="form.document_type_id"
                                              label="Tipo comprobante"
                                              :options="document_types"
                                              :disabled="!!form.id"
                                              @input="changeDocumentType"></x-select>
                                </div>
                                <div class="col-lg-4">
                                    <x-input v-model="form.number_full"
                                             readonly
                                             label="Número"
                                             v-if="form.id"></x-input>
                                    <x-select v-model="form.series"
                                              label="Serie"
                                              :options="series"
                                              option-label="number"
                                              option-value="number"
                                              v-else
                                              :disabled="!!form.id"></x-select>
                                </div>
                                <div class="col-lg-4" v-if="is_contingency && establishment.contingencia_manual_nuber">
                                    <x-input v-model="form.number"
                                             label="Número"></x-input>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-12">
                                    <div class="form-group" :class="{'has-danger': errors.customer_id}">
                                        <label class="control-label font-weight-bold text-info">
                                            Cliente
                                            <a href="#"
                                               @click.prevent="showDialogNewPerson = true">[+ Nuevo]</a>
                                            <a href="#"
                                               v-if="form.customer_id"
                                               @click.prevent="showDialogDocuments = true">[Ver documentos]</a>
                                        </label>
                                        <el-select v-model="form.customer_id"
                                                   :loading="loading_search"
                                                   :remote-method="searchRemoteCustomers"
                                                   class="border-left rounded-left border-info"
                                                   dusk="customer_id"
                                                   filterable
                                                   @focus="focus_on_client = true"
                                                   @blur="focus_on_client = false"
                                                   placeholder="Escriba el nombre o número de documento del cliente"
                                                   popper-class="el-select-customers"
                                                   remote
                                                   @change="changeCustomer"
                                                   @keyup.enter.native="keyupCustomer">

                                            <el-option v-for="option in customers"
                                                       :key="option.id"
                                                       :label="option.description"
                                                       :value="option.id"></el-option>

                                        </el-select>
                                        <small v-if="errors.customer_id"
                                               class="form-control-feedback"
                                               v-text="errors.customer_id[0]"></small>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-12" v-if="customer_addresses.length > 0">
                                    <div class="form-group">
                                        <label class="control-label font-weight-bold text-info">Dirección</label>
                                        <el-select v-model="form.customer_address_id">
                                            <el-option v-for="option in customer_addresses"
                                                       :key="option.id"
                                                       :label="option.address"
                                                       :value="option.id"></el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-12" v-if="config.enabled_point_system && form.customer_id">
                                    <div class="font-weight-bold text-info">Puntos acumulados: <b>{{ customer_accumulated_points }}</b>
                                        <template v-if="total_exchange_points > 0">
                                            - <b style="color:red">{{ total_exchange_points }}</b> =
                                            <b>{{ calculate_customer_accumulated_points }}</b>
                                        </template>
                                    </div>
                                    <div class="font-weight-bold text-danger">Puntos por la compra: <b>{{ total_points_by_sale }}</b></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="row">
                                <div class="col-lg-4">
                                    <x-select v-model="form.operation_type_id"
                                              label="Tipo Operación"
                                              :options="operation_types"
                                              @input="changeOperationType"></x-select>
                                </div>
                                <div class="col-lg-4">
                                    <div :class="{'has-danger': errors.date_of_issue}"
                                         class="form-group">
                                        <label class="control-label">Fecha de emisión</label>
                                        <el-date-picker v-model="form.date_of_issue"
                                                        :clearable="false"
                                                        :picker-options="dateIssue"
                                                        :readonly="readonly_date_of_due"
                                                        type="date"
                                                        format="dd/MM/yyyy"
                                                        value-format="yyyy-MM-dd"
                                                        @change="changeDateOfIssue"></el-date-picker>
                                        <small v-if="errors.date_of_issue"
                                               class="form-control-feedback"
                                               v-text="errors.date_of_issue[0]"></small>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <x-date-picker v-model="form.date_of_due"
                                                   label="Fec. Vencimiento"
                                                   :readonly="true"></x-date-picker>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-4">
                                    <x-select v-model="form.currency_type_id"
                                              label="Moneda"
                                              :options="currency_types"
                                              option-label="symbol"
                                              @input="changeCurrencyType">
                                    </x-select>
                                </div>
                                <div class="col-lg-4">
                                    <x-input v-model="form.exchange_rate_sale"
                                             label="Tipo de cambio"
                                             readonly></x-input>
                                </div>
                                <div class="col-lg-4">
                                    <x-select v-model="form.seller_id"
                                              :disable="typeUser === 'seller' && !orderNotesAdvancedPermissions"
                                              label="Vendedor"
                                              :options="sellers">
                                    </x-select>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-4" v-if="config.documents_enable_purchase_order">
                                    <x-input v-model="form.purchase_order"
                                             label="Orden de Compra"></x-input>
                                </div>
                                <div class="col-lg-4" v-if="config.documents_enable_plate_number">
                                    <x-input v-model="form.plate_number"
                                             label="Nro. de Placa"></x-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 table-responsive">
                            <table class="table table-sm">
                                <thead>
                                <tr>
                                    <th width="5%">#</th>
                                    <th class="font-weight-bold"
                                        width="30%">Descripción
                                    </th>
                                    <th class="text-center font-weight-bold">Unidad</th>
                                    <th class="text-right font-weight-bold">Cantidad</th>
                                    <th class="text-right font-weight-bold">Valor Unitario</th>
                                    <th class="text-right font-weight-bold">Precio Unitario</th>
                                    <th class="text-right font-weight-bold">Subtotal</th>
                                    <!--<th class="text-right font-weight-bold">Cargo</th>-->
                                    <th class="text-right font-weight-bold">Total</th>
                                    <th width="8%" v-if="showItemButtonAction"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(row, index) in form.items" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ setDescriptionOfItem(row) }}
                                        {{
                                            row.item.presentation.hasOwnProperty('description') ?
                                                row.item.presentation.description : ''
                                        }}
                                        <template v-if="row.total_plastic_bag_taxes > 0">
                                            <br/><small>ICBPER: {{ currency_type.symbol }}
                                            {{ row.total_plastic_bag_taxes }}</small>
                                        </template>
                                        <br/><small>{{ row.affectation_igv_type_name }}</small>
                                        <template v-if="row.lots && row.lots.length > 0">
                                            <br/>Series: {{ showItemSeries(row.lots) }}
                                        </template>

                                        <!-- sistema por puntos -->
                                        <template
                                            v-if="config.enabled_point_system && customer_accumulated_points > 0 && row.item.exchange_points">
                                            <el-checkbox class="mt-2 mb-2" v-model="row.item.exchanged_for_points"
                                                         @change="changeRowExchangePoints(row, index)">
                                                <b>{{ getExchangePointDescription(row) }}</b></el-checkbox>
                                        </template>
                                        <!-- sistema por puntos -->

                                        <template v-if="fnApplyRestrictSaleItemsCpe && isGeneratedFromExternal">
                                            <template v-if="fnIsRestrictedForSale(row.item, form.document_type_id)">
                                                <span
                                                    class="text-danger mt-1 mb-2 d-block">Restringido para venta en CPE</span>
                                            </template>
                                        </template>
                                        <template v-if="row.warehouse_id">
                                            <div v-if="row.item.warehouses"><b>{{ warehouseSeleted(row.item.warehouses, row.warehouse_id, row) }}</b></div>
                                        </template>
                                        <div v-if="form.operation_type_id === '0202'" style="width: 100%">
                                            <a href="#" @click.prevent="clickAddAccommodationAttribute(row, index)">Agregar datos del huésped</a>
                                        </div>
                                    </td>
                                    <td class="text-center">{{ row.unit_type_id }}</td>
                                    <td class="text-right">{{ row.quantity }}</td>
                                    <td class="text-right">{{ currency_type.symbol }}
                                        {{ getFormatUnitPriceRow(row.unit_value) }}
                                    </td>
                                    <td class="text-right">{{ currency_type.symbol }}
                                        {{ getFormatUnitPriceRow(row.unit_price) }}
                                    </td>
                                    <td class="text-right">{{ currency_type.symbol }} {{ row.total_value }}</td>
                                    <td class="text-right">{{ currency_type.symbol }} {{ row.total }}</td>
                                    <td class="text-right" v-if="showItemButtonAction">
                                        <button class="btn waves-effect waves-light btn-xs btn-danger"
                                                type="button"
                                                @click.prevent="clickRemoveItem(index)"><i class="fas fa-trash"></i>
                                        </button>
                                        <button class="btn waves-effect waves-light btn-xs btn-info"
                                                type="button"
                                                @click="ediItem(row, index)">
                                            <span style='font-size:10px;'>&#9998;</span></button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12 col-lg-4">
                            <button class="btn waves-effect waves-light btn-primary"
                                    type="button"
                                    v-if="showItemButtonAction"
                                    @click.prevent="clickAddItemInvoice">+ Agregar Producto
                            </button>
                        </div>
                        <div class="col-12 col-md-8 table-responsive">
                            <table class="table table-sm text-right" v-if="form && form.items.length > 0">
                                <tbody>
                                <tr v-if="enabled_discount_global">
                                    <td>DESCUENTOS (-)</td>
                                    <td>:</td>
                                    <td style="width: 64px">
                                        <x-select v-model="discount_global_type"
                                                  :options="[{'id': '01', 'name': currency_type.symbol}, {'id': '02', 'name': '%'}]"
                                                  :disable="!showItemButtonAction"
                                                  @input="changeDiscountGlobalType">
                                        </x-select>
                                    </td>
                                    <td>
                                        <el-input-number v-model="discount_global_amount"
                                                         :min="0"
                                                         class="input-custom"
                                                         controls-position="right"
                                                         :disabled="!showItemButtonAction"
                                                         @change="calculateTotal"></el-input-number>
                                    </td>
                                </tr>
                                <tr v-if="form.total_prepayment > 0">
                                    <td>DESC. ANTICIPOS</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_prepayment }}</td>
                                </tr>
                                <tr v-if="form.total_exportation > 0">
                                    <td>OP.EXPORTACIÓN</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_exportation }}</td>
                                </tr>
                                <tr v-if="form.total_free > 0">
                                    <td>OP.GRATUITAS</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_free }}</td>
                                </tr>
                                <tr v-if="form.total_unaffected > 0">
                                    <td>OP.INAFECTAS</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_unaffected }}</td>
                                </tr>
                                <tr v-if="form.total_exonerated > 0">
                                    <td>OP.EXONERADAS</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_exonerated }}</td>
                                </tr>
                                <tr v-if="form.total_taxed > 0">
                                    <td>OP.GRAVADA</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_taxed }}</td>
                                </tr>
                                <tr>
                                    <td>SUBTOTAL</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.subtotal }}</td>
                                </tr>
                                <tr>
                                    <td>IGV</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td style="width: 100px">{{ form.total_igv }}</td>
                                </tr>
                                <tr v-if="form.total_isc > 0">
                                    <td>ISC</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_isc }}</td>
                                </tr>
                                <tr v-if="form.total_plastic_bag_taxes > 0">
                                    <td>ICBPER</td>
                                    <td>:</td>
                                    <td>{{ currency_type.symbol }}</td>
                                    <td>{{ form.total_plastic_bag_taxes }}</td>
                                </tr>
                                <template v-if="form.has_retention || form.has_detraction">
                                    <tr v-if="form.total > 0">
                                        <td><strong>IMPORTE TOTAL</strong></td>
                                        <td>:</td>
                                        <td>{{ currency_type.symbol }}</td>
                                        <td>{{ form.total }}</td>
                                    </tr>
                                    <tr v-if="form.detraction && form.detraction.amount > 0">
                                        <td>M. DETRACCIÓN ({{ form.detraction.percentage }}%)</td>
                                        <td>:</td>
                                        <td>{{ currency_type.symbol }}</td>
                                        <td>
                                            <template v-if="form.detraction.detraction_type_id == '027'">
                                                <el-input-number v-model="form.total_detraction" :min="0"
                                                                 class="input-custom" controls-position="right"
                                                                 @change="changeAmountDetraction"></el-input-number>
                                            </template>
                                            <template v-else>
                                                {{ form.total_detraction }}
                                            </template>
                                        </td>
                                    </tr>
                                    <tr v-if="form.retention && form.retention.amount > 0">
                                        <td>M. RETENCIÓN ({{ form.retention.percentage * 100 }}%)</td>
                                        <td>:</td>
                                        <td>{{ currency_type.symbol }}</td>
                                        <td>{{ form.total_retention }}</td>
                                    </tr>
                                </template>
                                <tr>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0;">TOTAL A PAGAR</td>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 40px">:</td>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0;">{{ currency_type.symbol }}</td>
                                    <td style="font-weight: bolder; font-size: 18px; padding: 16px 0; width: 100px">{{ form.total_payment }}</td>
                                </tr>
                                <tr v-if="form.total > 0">
                                    <td>CONDICIÓN DE PAGO</td>
                                    <td class="text-left">:</td>
                                    <td colspan="2">
                                        <x-select v-model="form.payment_condition_id"
                                                  :options="payment_conditions"
                                                  @input="changePaymentCondition"></x-select>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 text-right">
                            <button class="btn btn-default"
                                    style="min-width: 180px"
                                    @click.prevent="close">Cancelar
                            </button>
                            <x-button-submit :text="btnText"
                                             :loading="loading_submit"
                                             :disabled="loading_submit"
                                             @click="preSubmit"
                                             v-if="form.items.length > 0"></x-button-submit>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-12">
                    <div class="row">
                        <template v-if="!is_client">
                            <div class="col-12">
                                <x-switch-left v-model="form.is_prepayment"
                                               label="¿Es un pago anticipado?"
                                               :disable="prepayment_deduction"
                                               is-dense
                                               @input="changeHasPrepayment"></x-switch-left>
                            </div>
                            <div class="col-12">
                                <x-switch-left v-model="prepayment_deduction"
                                               label="¿Tiene deducción de los pagos anticipados?"
                                               :disable="!form.customer_id || form.is_prepayment"
                                               is-dense
                                               @input="changePrepaymentDeduction"></x-switch-left>
                            </div>
                            <template v-if="prepayment_deduction">
                                <div class="col-12">
                                    <table style="width: 100%">
                                        <tr v-for="(row,index) in form.prepayments"
                                            :key="index">
                                            <td>
                                                <el-select v-model="row.document_id"
                                                           filterable
                                                           @change="changeDocumentPrepayment(index)">
                                                    <el-option v-for="option in prepayment_documents"
                                                               :key="option.id"
                                                               :label="option.number"
                                                               :value="option.id"></el-option>
                                                </el-select>
                                            </td>
                                            <td>
                                                <el-input v-model="row.total" readonly></el-input>
                                            </td>
                                            <td align="right">
                                                <button
                                                    class="btn waves-effect waves-light btn-xs btn-danger"
                                                    type="button"
                                                    @click.prevent="clickRemovePrepayment(index)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-12">
                                    <a class=""
                                       href="#"
                                       @click.prevent="clickAddPrepayment"><i
                                        class="fa fa-plus font-weight-bold text-info"></i>
                                        <span
                                            style="color: #777777">Agregar comprobante anticipado</span></a>
                                </div>
                            </template>
                            <div class="col-12" v-if="show_has_retention">
                                <x-switch-left v-model="form.has_retention"
                                               label="¿Tiene retención de igv?"
                                               is-dense
                                               @input="changeRetention"></x-switch-left>
                            </div>
                        </template>
                        <div class="col-12">
                            <div class="form-group">
                                <label class="control-label">Observaciones</label>
                                <el-input v-model="form.observations"
                                          autosize
                                          type="textarea">
                                </el-input>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label class="control-label">
                                    Guías
                                </label>
                                <table style="width: 100%">
                                    <tr v-for="(guide,index) in form.guides">
                                        <td>
                                            <x-select v-model="guide.document_type_id"
                                                      :options="document_types_guide"></x-select>
                                        </td>
                                        <td>
                                            <el-input v-model="guide.number"></el-input>
                                        </td>
                                        <td align="right">
                                            <button
                                                class="btn waves-effect waves-light btn-xs btn-danger"
                                                type="button"
                                                @click.prevent="clickRemoveGuide(index)">
                                                <i class="fa fa-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <label class="control-label">
                                                <a class=""
                                                   href="#"
                                                   @click.prevent="clickAddGuide"><i
                                                    class="fa fa-plus font-weight-bold text-info"></i>
                                                    <span
                                                        style="color: #777777">Agregar guía</span></a>

                                            </label>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <template v-if="config.enabled_tips_pos && !isUpdateDocument">
                            <set-tip class="full py-2 border-top mb-1 mt-2"
                                     @changeDataTip="changeDataTip"></set-tip>
                        </template>
                        <div class="col-12">
                            <x-switch-left v-model="form.show_terms_condition"
                                           label="Mostrar términos y condiciones."
                                           is-dense></x-switch-left>
                        </div>
                        <!--                        <div class="col-12">-->
                        <!--                            <el-collapse v-model="activePanel" accordion>-->
                        <!--                                <el-collapse-item name="1">-->
                        <!--                                    <template slot="title">-->
                        <!--                                        <span class="ml-2">Información Adicional</span>-->
                        <!--                                    </template>-->
                        <!--                                    <div class="row p-2 border-top">-->
                        <!--                                        <div class="col-12">-->
                        <!--                                            <template v-if="!isActiveBussinessTurn('tap')">-->
                        <!--                                                <template v-if="!is_client">-->
                        <!--                                                </template>-->
                        <!--                                            </template>-->
                        <!--                                            <template v-else>-->
                        <!--                                                <template v-if="!is_client">-->
                        <!--                                                    <div class="form-group">-->
                        <!--                                                        <label class="control-label">-->
                        <!--                                                            Guías-->
                        <!--                                                        </label>-->
                        <!--                                                        <table style="width: 100%">-->
                        <!--                                                            <tr v-for="(guide,index) in form.guides">-->
                        <!--                                                                <td>-->
                        <!--                                                                    <el-select v-model="guide.document_type_id">-->
                        <!--                                                                        <el-option-->
                        <!--                                                                            v-for="option in document_types_guide"-->
                        <!--                                                                            :key="option.id"-->
                        <!--                                                                            :label="option.description"-->
                        <!--                                                                            :value="option.id"></el-option>-->
                        <!--                                                                    </el-select>-->
                        <!--                                                                </td>-->
                        <!--                                                                <td>-->
                        <!--                                                                    <el-input v-model="guide.number"></el-input>-->
                        <!--                                                                </td>-->
                        <!--                                                                <td align="right">-->
                        <!--                                                                    <button-->
                        <!--                                                                        class="btn waves-effect waves-light btn-xs btn-danger"-->
                        <!--                                                                        type="button"-->
                        <!--                                                                        @click.prevent="clickRemoveGuide(index)">-->
                        <!--                                                                        <i class="fa fa-trash"></i>-->
                        <!--                                                                    </button>-->
                        <!--                                                                </td>-->
                        <!--                                                            </tr>-->
                        <!--                                                            <tr>-->
                        <!--                                                                <td colspan="3">-->
                        <!--                                                                    <label class="control-label">-->
                        <!--                                                                        <a class=""-->
                        <!--                                                                           href="#"-->
                        <!--                                                                           @click.prevent="clickAddGuide"><i-->
                        <!--                                                                            class="fa fa-plus font-weight-bold text-info"></i>-->
                        <!--                                                                            <span-->
                        <!--                                                                                style="color: #777777">Agregar guía</span></a>-->

                        <!--                                                                    </label>-->
                        <!--                                                                </td>-->
                        <!--                                                            </tr>-->
                        <!--                                                        </table>-->
                        <!--                                                    </div>-->
                        <!--                                                </template>-->
                        <!--                                            </template>-->
                        <!--                                        </div>-->
                        <!--                                        &lt;!&ndash; propinas &ndash;&gt;-->
                        <!--                                    </div>-->
                        <!--                                </el-collapse-item>-->
                        <!--                            </el-collapse>-->
                        <!--                        </div>-->
                        <div class="col-12">
                            <button class="btn btn-primary btn-block mt-2"
                                    :disabled="form.customer_id == null"
                                    @click.prevent="visibleDialogReportCustomer">Consulta de documentos
                            </button>
                        </div>
                        <div class="col-12" style="margin-top: 8px"
                             v-if="configuration.enabled_label_by_sale && form.customer_id">
                            <x-button-primary text="Agregar rótulo"
                                              :disabled="!form.customer_id"
                                              @click="registerLabel"></x-button-primary>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <document-report-customer :showDialog.sync="showDialogReportCustomer"
                                  :customerId="report_to_customer_id"></document-report-customer>

        <document-form-item :showDialog.sync="showDialogAddItem"
                            :typeUser="typeUser"
                            :configuration="config"
                            :currency-types="currency_types"
                            :currency-type-id-active="form.currency_type_id"
                            :exchange-rate-sale="form.exchange_rate_sale"
                            :documentId="documentId"
                            :editNameProduct="config.edit_name_product"
                            :isEditItemNote="false"
                            :operation-type-id="form.operation_type_id"
                            :recordItem="recordItem"
                            :customer-id="form.customer_id"
                            :is-from-invoice="true"
                            :percentage-igv="percentage_igv"
                            :isUpdateDocument="isUpdateDocument"
                            table="documents"
                            @add="addRow"></document-form-item>

        <person-form :document_type_id=form.document_type_id
                     :external="true"
                     :input_person="input_person"
                     :showDialog.sync="showDialogNewPerson"
                     type="customers"
                     @success="successPerson"></person-form>

        <store-finish :showDialog.sync="showDialogOptions"
                      :isContingency="is_contingency"
                      :typeUser="typeUser"
                      :record-data="recordData"
                      :resource="resource"
                      :parent-table="parentTable"
                      :show-new="showNew"
                      :configuration="config"></store-finish>

        <document-detraction :currency-type-id-active="form.currency_type_id"
                             :detraction="form.detraction"
                             :exchange-rate-sale="form.exchange_rate_sale"
                             :operation-type-id="form.operation_type_id"
                             :showDialog.sync="showDialogDocumentDetraction"
                             :total="form.total"
                             :isUpdateDocument="isUpdateDocument"
                             :detractionDecimalQuantity="detractionDecimalQuantity"
                             @addDocumentDetraction="addDocumentDetraction"></document-detraction>

        <store-item-series-index :show-dialog.sync="showDialogItemSeriesIndex"
                                 :item="recordItem"
                                 :document-id="documentId"
                                 @success="successItemSeries"></store-item-series-index>

        <store-document-items :show-dialog.sync="showDialogDocuments"
                              :resource="resource"
                              table="documents"
                              :document-type-id="form.document_type_id"
                              :person-id="form.customer_id"
                              @success="successStoreDocuments"></store-document-items>

        <store-document-payments :show-dialog.sync="showDialogDocumentPayments"
                                 :data="form"
                                 :form-id="documentId"
                                 @success="successDocumentPayments"></store-document-payments>

        <store-document-fee :show-dialog.sync="showDialogDocumentFee"
                            :data="form"
                            :form-id="documentId"
                            @success="successDocumentFee"></store-document-fee>

        <store-label-form :show-dialog.sync="showDialogLabel"
                          :record="formLabel"
                          @success="successRegisterLabel"></store-label-form>

        <store-accommodation-attribute :show-dialog.sync="showDialogAccommodationAttribute"
                                       :record="recordItem.accommodation_attributes"
                                       v-if="recordItem"
                                       @success="successRegisterAccommodationAttribute"></store-accommodation-attribute>
    </div>
</template>

<script>

import DocumentFormItem from './partials/item.vue'
import PersonForm from '../persons/form.vue'
import DocumentOptions from '../Documents/partials/Options.vue'
import {exchangeRate, functions, pointSystemFunctions, fnRestrictSaleItemsCpe} from '../../../mixins/functions'
import {
    calculateRowItem,
    fCalculateDiscountGlobal,
    fCalculateTotal,
    showNamePdfOfDescription,
    showNamePdfOfDescription2,
    fCalculateDiscountGlobalPrepayment
} from '../../../helpers/functions_3'
import Logo from '../companies/logo.vue'
import DocumentHotelForm from '../BusinessTurn/hotels/form.vue'
import DocumentTransportForm from '../BusinessTurn/transports/form.vue'
import DocumentDetraction from './partials/detraction.vue'
import moment from 'moment'
import {mapActions, mapState} from "vuex/dist/vuex.mjs";
import Keypress from "vue-keypress";
import StoreItemSeriesIndex from "../Store/ItemSeriesIndex";
import DocumentReportCustomer from './partials/report_customer.vue'
import SetTip from '@components/SetTip.vue'

import LotsForm from './partials/lots.vue'
import XButtonSubmit from "../../../components/Form/XButtonSubmit";
import XButtonPrimary from "../../../components/Form/XButtonPrimary";
import StoreDocumentItems from "../Store/DocumentItems.vue";
import StoreDocumentPayments from "./partials/DocumentPayment.vue";
import StoreDocumentFee from "./partials/DocumentFee.vue";
import XSelect from "../../../components/Form/XSelect.vue";
import XInput from "../../../components/Form/XInput.vue";
import XDatePicker from "../../../components/Form/XDatePicker.vue";
import {includes} from "lodash/collection";
import StoreLabelForm from "../Store/LabelForm.vue";
import StoreAccommodationAttribute from "../Store/AccommodationAttribute.vue";
import SaleNotesFormItem from "./partials/item.vue";
import StoreFinish from "./partials/Finish.vue";
import XSwitch from "../../../components/Form/XSwitch.vue";
import XSwitchLeft from "../../../components/Form/XSwitchLeft.vue";

export default {
    props: [
        'idUser',
        'typeUser',
        'orderNotesAdvancedPermissions',
        'configuration',
        'documentId',
        'parentTable',
        'parentId',
        'action',
        'isUpdate',
        'authUser',
        "copy",
    ],
    components: {
        XSwitchLeft,
        XSwitch,
        StoreFinish,
        SaleNotesFormItem,
        StoreAccommodationAttribute,
        StoreLabelForm,
        XDatePicker,
        XInput,
        XSelect,
        StoreDocumentItems,
        XButtonPrimary,
        XButtonSubmit,
        StoreItemSeriesIndex,
        DocumentFormItem,
        PersonForm,
        DocumentOptions,
        Logo,
        DocumentHotelForm,
        Keypress,
        DocumentDetraction,
        DocumentTransportForm,
        DocumentReportCustomer,
        StoreDocumentPayments,
        StoreDocumentFee,
        SetTip,
        LotsForm,
    },
    mixins: [functions, exchangeRate, pointSystemFunctions, fnRestrictSaleItemsCpe],
    data() {
        return {
            loadForm: false,
            dateIssue: {
                disabledDate(time) {
                    return time.getTime() > moment();
                }
            },
            dateFee: {
                disabledDate(time) {
                    return time.getTime() <= moment();
                }
            },
            multiple: [
                {
                    keyCode: 78, // N
                    modifiers: ['altKey'],
                    preventDefault: true,
                },
                {
                    keyCode: 71, // g
                    modifiers: ['altKey'],
                    preventDefault: true,
                },
            ],
            title: '',
            focus_on_client: false,
            dateValid: false,
            input_person: {},
            showDialogDocumentDetraction: false,
            showDialogFormHotel: false,
            showDialogFormTransport: false,
            showDialogItemSeriesIndex: false,
            showDialogDocuments: false,
            showDialogDocumentPayments: false,
            showDialogDocumentFee: false,
            showDialogAccommodationAttribute: false,
            is_client: false,
            recordItem: null,
            resource: 'documents',
            showDialogAddItem: false,
            showDialogNewPerson: false,
            showDialogOptions: false,
            showDialogLabel: false,
            loading_submit: false,
            errors: {},
            form: {},
            document_types: [],
            currency_types: [],
            discount_types: [],
            charges_types: [],
            all_customers: [],
            business_turns: [],
            all_series: [],
            series: [],
            user_series: [],
            form_payment: {},
            document_types_guide: [],
            customers: [],
            sellers: [],
            company: null,
            document_type_03_filter: null,
            operation_types: [],
            // establishments: [],
            payment_method_types: [],
            establishment: null,
            prepayment_documents: [],
            currency_type: {},
            documentNewId: null,
            prepayment_deduction: false,
            total_detraction_input: 0,
            activePanel: 0,
            total_global_discount: 0,
            total_global_charge: 0,
            loading_search: false,
            is_amount: true,
            enabled_discount_global: false,
            enabled_charge_global: false,
            user: null,
            is_receivable: false,
            is_contingency: false,
            cat_payment_method_types: [],
            select_first_document_type_03: false,
            detraction_types: [],
            all_detraction_types: [],
            customer_addresses: [],
            payment_destinations: [],
            form_cash_document: {},
            enabled_payments: true,
            readonly_date_of_due: false,
            seller_class: 'col-lg-6 pb-2',
            payment_conditions: [],
            affectation_igv_types: [],
            total_discount_no_base: 0,
            show_has_retention: true,
            global_discount_types: [],
            global_discount_type: {},
            error_global_discount: false,
            headers_token: headers_token,
            showDialogReportCustomer: false,
            report_to_customer_id: null,
            retention_query_data: null,
            has_discount_type: null,
            discount_type: null,
            discount_amount: null,
            discount_global_type: '01',
            discount_global_amount: 0,
            // discount_global_percentage: 0,
            formLabel: {},
            recordData: null,
            establishmentId: null,
            sellerId: null,
            showNew: false,
            //formAccommodationAttribute: {}
        }
    },
    computed: {
        showItemButtonAction() {
            return (this.action === 'new' && this.parentTable === null) || this.action === 'edit' || this.action === 'duplicate'
        },
        btnText() {
            return ['01', '02'].includes(this.form.payment_condition_id) ? 'Continuar' : 'Generar';
        },
        isGeneratedFromExternal() {
            return (this.parentTable != undefined && this.parentTable) && (this.parentId != undefined && this.parentId)
        },
        showLoadVoucher() {
            return this.configuration.show_load_voucher && !this.isUpdateDocument
        },
        isGlobalDiscountBase: function () {
            return (this.configuration.global_discount_type_id === '02')
        },
        ...mapState([
            'config',
            // 'series',
            // 'all_series',
        ]),
        credit_payment_metod: function () {
            return _.filter(this.payment_method_types, {'is_credit': true})
        },
        cash_payment_metod: function () {
            return _.filter(this.payment_method_types, {'is_credit': false})
        },
        existDiscountsNoBase: function () {
            return this.total_discount_no_base > 0
        },
        isUpdateDocument: function () {
            return !!(this.documentId)
        },
        isCreditPaymentCondition: function () {
            return !['01'].includes(this.form.payment_condition_id)
        },
        detractionDecimalQuantity: function () {
            return (this.configuration.detraction_amount_rounded_int) ? 0 : 2
        },
        isAutoPrint: function () {
            if (this.configuration) {
                return this.configuration.auto_print
            }
            return false
        },
        hidePreviewPdf: function () {
            if (this.configuration) {
                return this.configuration.hide_pdf_view_documents
            }
            return false
        },
    },
    async created() {
        console.log('created')
        this.loadForm = false
        this.loadConfiguration()
        this.$store.commit('setConfiguration', this.configuration)
        this.initForm()
        await this.$http.get(`/store/get_tables`)
            .then(response => {
                let data = response.data
                this.document_types = data.document_types.filter(row => ['01', '03'].includes(row.id));
                this.document_types_guide = data.document_types.filter(row => ['09', '31'].includes(row.id));
                this.currency_types = data.currency_types
                this.business_turns = data.business_turns
                this.operation_types = data.operation_types
                this.all_series = data.series
                this.establishment = data.establishment
                this.user_series = data.user_series
                //this.$store.commit('setAllSeries', data.series)
                this.all_customers = data.customers
                this.discount_types = data.discount_types
                this.charges_types = data.charges_types
                this.payment_method_types = data.payment_method_types
                this.enabled_discount_global = data.enabled_discount_global
                this.enabled_charge_global = data.enabled_charge_global
                this.company = data.company;
                this.user = data.user;
                this.document_type_03_filter = data.document_type_03_filter;
                this.select_first_document_type_03 = data.select_first_document_type_03
                this.affectation_igv_types = data.affectation_igv_types
                this.is_client = data.is_client;
                this.payment_destinations = data.payment_destinations
                this.payment_conditions = data.payment_conditions;
                this.seller_class = (this.user === 'admin') ? 'col-lg-4 pb-2' : 'col-lg-6 pb-2';
                this.global_discount_types = data.global_discount_types
                this.sellers = data.sellers
                this.sellerId = data.seller_id
                this.establishmentId = data.establishment_id
            })

        this.initFormData()
        await this.getPercentageIgv()

        if (this.parentTable) {
            let url = `/store/record/${this.parentTable}/${this.parentId}/${this.resource}`
            if (this.action) {
                url += `/${this.action}`
            }
            try {
                const response = await this.$http.get(url);
                const data = response.data;

                // Actualizar `form` con los datos obtenidos
                this.form = {...this.form, ...data.form};

                // Procesar los items
                this.form.items = data.items.map(row => calculateRowItem(row, this.percentage_igv));

                // Verificar y procesar prepagos
                this.prepayment_deduction = this.form.has_prepayments;
                if (this.prepayment_deduction) {
                    await this.getDocumentsPrepayment(); // Aseguramos que se ejecute correctamente
                    this.form.prepayments.forEach(row => {
                        this.prepayment_documents.push({
                            id: row.document_id,
                            number: row.number,
                            document_type_id: row.document_type_id,
                            total_exonerated: row.total_exonerated,
                            total_unaffected: row.total_unaffected,
                            total_taxed: row.total_taxed,
                            total_igv: row.total_igv,
                            total: row.total,
                        })
                    })
                }

                // Actualizar otros valores del formulario
                this.customers = data.persons;
                this.discount_global_type = data.general.discount_global_type;
                this.discount_global_amount = data.general.discount_global_amount;

                // Calcular el total
                this.calculateTotal();
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading_submit = false;
            }

            // await this.$http.get(url)
            //     .then(response => {
            //         let data = response.data
            //         this.form = Object.assign({}, this.form, data.form)
            //         let its = []
            //         data.items.forEach((row) => {
            //             its.push(calculateRowItem(row, this.percentage_igv))
            //         })
            //         this.form.items = its
            //         this.prepayment_deduction = this.form.has_prepayments
            //         if(this.prepayment_deduction) {
            //             this.getDocumentsPrepayment()
            //             this.form.prepayments.forEach(row => {
            //                 this.prepayment_documents.push(row)
            //             })
            //             console.log(this.prepayment_documents)
            //         }
            //         this.customers = data.persons
            //         this.discount_global_type = data.general.discount_global_type
            //         this.discount_global_amount = data.general.discount_global_amount
            //         this.calculateTotal()
            //     })
            //     .finally(() => this.loading_submit = false)
            if (this.action !== 'edit') {
                this.filterSeries()
            }
            this.currency_type = this.currency_types.find(row => row.id === this.form.currency_type_id)
        } else {
            await this.changeDateOfIssue()
            this.selectDefaultDocumentType()
            await this.selectDefaultCustomer()
            // this.changeDocumentType()
            this.changeCurrencyType()
            this.filterCustomers()
            this.filterSeries()
        }

        // this.filterSeries()
        // this.cleanCustomer()
        // this.filterCustomers()
        if (this.action === 'new' || this.action === 'duplicate') {
            this.showNew = true
        }

        this.title = 'Nuevo comprobante'
        if (this.form.id) {
            this.title = 'Editar comprobante'
        }

        this.startConnectionQzTray()
        if (this.copy) {
            this.form.id = null;
            this.form.number = "#";
        }
        this.loadForm = true
    },
    mounted() {
        if (!this.documentId) {
            setInterval(() => this.changeTimeOfIssue(), 1000)
        }
    },
    methods: {
        ...mapActions([
            'loadConfiguration',
        ]),
        changeTimeOfIssue() {
            let time_of_issue = moment().format("HH:mm:ss")
            this.form.time_of_issue = time_of_issue
            if (time_of_issue === '00:00:01') {
                location.reload()
            }
        },
        initForm() {
            console.log('initForm')
            this.errors = {}
            this.form = {
                operation_type_id: '0101',
                establishment_id: null,
                document_type_id: '01',
                seller_id: this.idUser,
                series: null,
                number: '#',
                date_of_issue: moment().format('YYYY-MM-DD'),
                time_of_issue: moment().format('HH:mm:ss'),
                customer_id: null,
                currency_type_id: this.config.currency_type_id,
                purchase_order: null,
                exchange_rate_sale: 0,
                total_prepayment: 0,
                total_charge: 0,
                total_discount: 0,
                total_exportation: 0,
                total_free: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total_igv: 0,
                total_base_isc: 0,
                total_isc: 0,
                total_base_other_taxes: 0,
                total_other_taxes: 0,
                total_plastic_bag_taxes: 0,
                total_taxes: 0,
                total_value: 0,
                total: 0,
                total_payment: 0,
                total_retention: 0,
                total_detraction: 0,
                subtotal: 0,
                total_igv_free: 0,
                date_of_due: moment().format('YYYY-MM-DD'),
                items: [],
                charges: [],
                discounts: [],
                attributes: [],
                guides: [],
                payments: [],
                prepayments: [],
                legends: [],
                detraction: null,
                additional_information: null,
                plate_number: null,
                is_prepayment: false,
                has_prepayments: false,
                affectation_type_prepayment: null,
                actions: {
                    format_pdf: 'a4',
                },
                hotel: {},
                transport: {},
                customer_address_id: null,
                pending_amount_prepayment: 0,
                payment_method_type_id: null,
                show_terms_condition: true,
                terms_condition: '',
                payment_condition_id: '01',
                fee: [],
                total_pending_payment: 0,
                has_detraction: false,
                has_retention: false,
                retention: null,
                quotation_id: null,
                order_note_id: null,
                sales_note_id: null,
                worker_full_name_tips: null, //propinas
                total_tips: 0, //propinas
                label: null,
                observations: null,
                accommodation_attributes: null
            }

            this.form_cash_document = {
                document_id: null,
                sale_note_id: null
            }

            this.clickAddInitGuides()
            this.is_receivable = false
            this.total_global_discount = 0
            this.total_global_charge = 0
            this.is_amount = true
            this.prepayment_deduction = false
            this.imageDetraction = {}
            this.$eventHub.$emit('eventInitForm')
            this.initInputPerson()
            if (!this.config.restrict_receipt_date) {
                this.dateIssue = {}
            }
            this.enabled_payments = true
            this.readonly_date_of_due = false
            this.total_discount_no_base = 0
            this.calculate_customer_accumulated_points = 0
            this.total_exchange_points = 0
            this.retention_query_data = null
            this.customer_addresses = []
            this.discount_global_type = '01'
            this.discount_global_amount = 0
            this.$eventHub.$emit('eventInitTip')
        },
        selectDefaultDocumentType() {
            // console.log('selectDefaultDocumentType')
            if (this.configuration.default_document_type_03) {
                this.form.document_type_id = "03";
            } else {
                this.form.document_type_id = "01";
            }
            //  else {
            //     this.form.document_type_id = this.customer.identity_document_type_id === "6" ? "01" : "03";
            // }
        },
        initFormData() {
            this.form.establishment_id = this.establishmentId
            this.form.seller_id = this.sellerId
            this.form.operation_type_id = (this.operation_types.length > 0) ? this.operation_types[0].id : null
            this.form.document_type_id = (this.document_types.length > 0) ? this.document_types[0].id : null
        },
        async resetForm() {
            console.log('resetForm')
            this.activePanel = 0
            this.initForm()
            this.initFormData()
            //this.form.establishment_id = (this.establishments.length > 0) ? this.establishments[0].id : null
            //this.form.document_type_id = (this.document_types.length > 0) ? this.document_types[0].id : null
            //this.form.operation_type_id = (this.operation_types.length > 0) ? this.operation_types[0].id : null
            //this.form.seller_id = (this.sellers.length > 0) ? this.idUser : null;
            // this.selectDocumentType()
            // this.changeEstablishment()

            // this.filterSeries()
            // this.cleanCustomer()
            // this.filterCustomers()

            this.changeDocumentType()
            await this.changeDateOfIssue()
            this.changeCurrencyType()
            this.selectDefaultDocumentType()
            this.filterSeries()
            await this.selectDefaultCustomer()

            // this.filterSeries()
            // this.cleanCustomer()
            // this.filterCustomers()
        },
        changeDataTip(tip) {
            console.log('changeDataTip')
            if (tip) {
                this.form.worker_full_name_tips = tip.worker_full_name_tips
                this.form.total_tips = tip.total_tips
            }
        },
        onSuccessUploadVoucher(response, file, fileList, index) {
            console.log('onSuccessUploadVoucher')
            if (response.success) {
                this.form.payments[index].filename = response.data.filename
                this.form.payments[index].temp_path = response.data.temp_path
                this.form.payments[index].file_list = fileList
            } else {
                this.cleanFileListUploadVoucher(index)
                this.$message.error(response.message)
            }
        },
        cleanFileListUploadVoucher(index) {
            console.log('cleanFileListUploadVoucher')
            this.form.payments[index].file_list = []
        },
        handleRemoveUploadVoucher(file, fileList, index) {
            console.log('handleRemoveUploadVoucher')
            this.form.payments[index].filename = null
            this.form.payments[index].temp_path = null
            this.cleanFileListUploadVoucher(index)
        },
        startConnectionQzTray() {
            console.log('startConnectionQzTray')
            if (!qz.websocket.isActive() && this.isAutoPrint) {
                startConnection();
            }
        },
        changeRowExchangePoints(row, index) {
            console.log('changeRowExchangePoints')
            row.item.change_free_affectation_igv = !row.item.change_free_affectation_igv
            row.item.used_points_for_exchange = row.item.change_free_affectation_igv ? this.getUsedPoints(row) : null
            this.setTotalExchangePoints() //in mixins
            this.changeRowFreeAffectationIgv(row, index)
        },
        async changeRowFreeAffectationIgv(row, index) {
            console.log('changeRowFreeAffectationIgv')
            if (row.item.change_free_affectation_igv) {
                this.form.items[index].affectation_igv_type_id = '15'
                this.form.items[index].affectation_igv_type = await _.find(this.affectation_igv_types, {id: this.form.items[index].affectation_igv_type_id})
            } else {
                this.form.items[index].affectation_igv_type_id = this.form.items[index].item.original_affectation_igv_type_id
                this.form.items[index].affectation_igv_type = await _.find(this.affectation_igv_types, {id: this.form.items[index].affectation_igv_type_id})
            }
            this.form.items[index] = await calculateRowItem(row, this.percentage_igv)
            await this.calculateTotal()
        },
        setItemFromResponse(item, itemsParsed, sum_quantity = false) {
            console.log('setItemFromResponse')
            /* Obtiene el igv del item, si no existe, coloca el gravado*/
            if (item.sale_affectation_igv_type !== undefined) {
                item.affectation_igv_type = item.sale_affectation_igv_type
            } else {
                item.affectation_igv_type = {
                    active: 1,
                    description: "Gravado - Operación Onerosa",
                    exportation: 0,
                    free: 0,
                    id: "10",
                }
            }
            item.presentation = {};
            item.unit_price = item.sale_unit_price;
            item.item = {
                amount_plastic_bag_taxes: item.amount_plastic_bag_taxes,
                attributes: item.attributes,
                brand: item.brand,
                calculate_quantity: item.calculate_quantity,
                category: item.category,
                currency_type_id: item.currency_type_id,
                currency_type_symbol: item.currency_type_symbol,
                description: item.description,
                full_description: item.full_description,
                has_igv: item.has_igv,
                has_plastic_bag_taxes: item.has_plastic_bag_taxes,
                id: item.id,
                internal_id: item.internal_id,
                item_unit_types: item.item_unit_types,
                lots: item.lots,
                lots_enabled: item.lots_enabled,
                lots_group: item.lots_group,
                model: item.model,
                presentation: {},
                purchase_affectation_igv_type_id: item.purchase_affectation_igv_type_id,
                purchase_unit_price: item.purchase_unit_price,
                sale_affectation_igv_type_id: item.sale_affectation_igv_type_id,
                sale_unit_price: item.sale_unit_price,
                series_enabled: item.series_enabled,
                stock: item.stock,
                unit_price: item.sale_unit_price,
                unit_type_id: item.unit_type_id,
                warehouses: item.warehouses,
            };
            item.IdLoteSelected = null;
            if (item.affectation_igv_type_id === undefined) {
                item.affectation_igv_type_id = item.affectation_igv_type.id;
            }
            item.discounts = [];
            item.charges = [];
            item.item_id = item.id;
            item.unit_price_value = item.sale_unit_price;
            item.input_unit_price_value = item.sale_unit_price;
            item.quantity = 1;

            if (sum_quantity) {
                const quantity_from_item_response = this.getQuantityFromItemResponse(item, itemsParsed)
                if (quantity_from_item_response > 0) item.quantity = quantity_from_item_response
            } else {
                let tempItem = itemsParsed.find(ip => (ip.item_id === item.id) || (ip.id === item.id));
                if (tempItem !== undefined) {
                    item.quantity = tempItem.quantity
                }
            }
            item.warehouse_id = null;

            return item
        },
        getQuantityFromItemResponse(item, itemsParsed) {
            console.log('getQuantityFromItemResponse')
            const group_items = itemsParsed.filter(ip => (ip.item_id === item.id) || (ip.id === item.id))
            return _.sumBy(group_items, function (row) {
                return parseFloat(row.quantity)
            })
        },
        disabledSeries() {
            console.log('disabledSeries')
            return (this.configuration.restrict_series_selection_seller && this.typeUser !== 'admin')
        },
        // setDefaultSerieByDocument() {
        //     console.log('setDefaultSerieByDocument')
        //     if (this.authUser.multiple_default_document_types) {
        //         const default_document_type_serie = _.find(this.authUser.default_document_types, {document_type_id: this.form.document_type_id})
        //         if (default_document_type_serie) {
        //             const exist_serie = _.find(this.series, {id: default_document_type_serie.series_id})
        //             if (exist_serie) this.form.series_id = default_document_type_serie.series_id
        //         }
        //     }
        // },
        // #307 Ajuste para seleccionar automaticamente el tipo de comprobante y serie
        // setDefaultDocumentType(from_function) {
        //     console.log('setDefaultDocumentType')
        //     if (this.authUser.multiple_default_document_types) return
        //     this.default_series_type = this.config.user.serie;
        //     this.default_document_type = this.config.user.document_id;
        //     let alt = _.find(this.document_types, {'id': this.default_document_type});
        //     if (this.default_document_type !== null && alt !== undefined) {
        //         this.form.document_type_id = this.default_document_type;
        //         this.changeDocumentType()
        //         alt = _.find(this.series, {'id': this.default_series_type});
        //         if (this.default_series_type !== null && alt !== undefined) {
        //             this.form.series_id = this.default_series_type;
        //         }
        //     }
        // },
        async onSetFormData(data) {
            console.log('onSetFormData')
            this.form.establishment_id = data.establishment_id;
            this.form.document_type_id = data.document_type_id;
            this.form.id = data.id;
            this.form.hash = data.hash;
            this.form.number = data.number;
            this.form.date_of_issue = data.date_of_issue
            this.form.date_of_due = data.date_of_due
            this.form.time_of_issue = data.time_of_issue;
            this.form.customer_id = data.customer_id;
            this.form.currency_type_id = data.currency_type_id;
            this.form.exchange_rate_sale = data.exchange_rate_sale;
            this.form.external_id = data.external_id;
            this.form.filename = data.filename;
            this.form.group_id = data.group_id;
            this.form.perception = data.perception;
            this.form.note = data.note;
            this.form.plate_number = data.plate_number;
            this.form.payments = data.payments;
            this.form.prepayments = data.prepayments || [];
            this.form.legends = [];
            //this.form.detraction = data.detraction ? data.detraction : {}
            this.form.sale_notes_relateds = data.sale_notes_relateds ? data.sale_notes_relateds : null
            this.form.affectation_type_prepayment = data.affectation_type_prepayment;
            this.form.purchase_order = data.purchase_order;
            this.form.pending_amount_prepayment = data.pending_amount_prepayment || 0;
            this.form.payment_method_type_id = data.payment_method_type_id;
            this.form.charges = data.charges || [];
            this.form.discounts = this.prepareDataGlobalDiscount(data)
            this.form.seller_id = data.seller_id;

            if (this.table === 'dispatches' || this.table === 'quotations' || this.table === 'sale_notes' || this.table === 'order_notes') {
                let its = []
                data.items.forEach((row) => {
                    its.push(calculateRowItem(row, this.form.currency_type_id, this.form.exchange_rate_sale, this.percentage_igv))
                });
                this.form.items = its
            } else {
                this.form.items = this.onPrepareItems(data.items);
            }

            if (this.table !== 'quotations') {
                this.$store.commit('setSeries', this.onSetSeries(data.document_type_id, data.series))
            }
            this.form.state_type_id = data.state_type_id;
            this.form.total_discount = parseFloat(data.total_discount);
            this.form.total_exonerated = parseFloat(data.total_exonerated);
            this.form.total_exportation = parseFloat(data.total_exportation);
            this.form.total_free = parseFloat(data.total_free);
            this.form.total_igv = parseFloat(data.total_igv);
            this.form.total_isc = parseFloat(data.total_isc);
            this.form.total_base_isc = parseFloat(data.total_base_isc);
            this.form.total_base_other_taxes = parseFloat(data.total_base_other_taxes);
            this.form.total_other_taxes = parseFloat(data.total_other_taxes);
            this.form.total_plastic_bag_taxes = parseFloat(data.total_plastic_bag_taxes);
            this.form.total_prepayment = parseFloat(data.total_prepayment);
            this.form.total_taxed = parseFloat(data.total_taxed);
            this.form.total_taxes = parseFloat(data.total_taxes);
            this.form.total_unaffected = parseFloat(data.total_unaffected);
            this.form.total_value = parseFloat(data.total_value);
            this.form.total_charge = parseFloat(data.total_charge);
            this.form.total = parseFloat(data.total);
            this.form.subtotal = parseFloat(data.subtotal);
            this.form.total_igv_free = parseFloat(data.total_igv_free);
            this.form.series_id = this.onSetSeriesId(data.document_type_id, data.series);
            this.form.operation_type_id = data.invoice ? data.invoice.operation_type_id : data.operation_type_id;
            this.form.terms_condition = data.terms_condition || '';
            this.form.guides = data.guides || [];
            this.form.show_terms_condition = !!data.terms_condition;
            this.form.attributes = [];
            this.form.customer = data.customer;
            this.form.is_prepayment = false;
            this.form.has_prepayments = false;
            this.form.actions = {
                format_pdf: 'a4',
            };
            this.form.hotel = {}
            this.form.transport = {}
            this.form.customer_address_id = null
            this.form.type = 'invoice'
            this.form.invoice = {
                operation_type_id: data.invoice ? data.invoice.operation_type_id : data.operation_type_id,
                date_of_due: data.invoice ? data.invoice.date_of_due : data.date_of_due,
            }
            //let is_credit_installments = await _.find(data.fee, {payment_method_type_id: null})
            this.form.payment_condition_id = data.payment_condition_id
            this.form.fee = data.fee
            this.form.detraction = data.detraction
            this.form.retention = data.retention
            this.form.quotation_id = data.quotation_id
            this.form.order_note_id = data.order_note_id
            this.form.sale_note_id = data.sale_note_id
            this.form.dispatch_id = data.dispatch_id
            this.form.additional_information = this.onPrepareAdditionalInformation(data.additional_information)
            this.form.label = data.label
            this.form.accommodation_attributes = data.accommodation_attributes

            //this.form.total_init = 0
            this.discount_global_type = data.discount_global_type
            this.discount_global_amount = data.discount_global_amount

            this.prepareDataDetraction()
            this.prepareDataRetention()
            if (!data.guides) {
                this.clickAddInitGuides();
            }
            if (this.isGeneratedFromExternal) {
                this.preparePaymentsFee(data)
            }
            await this.reloadDataCustomers(this.form.customer_id)
            this.establishment = data.establishment;
            if (this.documentId === null) {
                this.changeDateOfIssue()
                this.changePaymentCondition()
            }
            this.prepareDataCustomer()
            this.calculateTotal();
        },
        preparePaymentsFee(data) {
            console.log('preparePaymentsFee')
        },
        prepareDataGlobalDiscount(data) {
            console.log('prepareDataGlobalDiscount')
            const discounts = data.discounts ? Object.values(data.discounts) : []
            if (discounts.length === 1) {
                if (discounts[0].is_amount !== undefined && discounts[0].is_amount !== null) {
                    this.is_amount = discounts[0].is_amount
                }
                this.total_global_discount = this.is_amount ? discounts[0].amount : (discounts[0].factor * 100)
            }

            return discounts
        },
        async prepareDataCustomer() {
            console.log('prepareDataCustomer')
            this.customer_addresses = [];
            let customer = await _.find(this.customers, {'id': this.form.customer_id})
            this.customer_addresses = customer.addresses
            this.form.customer_address_id = this.form.customer ? this.form.customer.address_id : null
            if (customer.address) {
                this.customer_addresses.unshift({
                    id: null,
                    address: customer.address
                })
            }
        },
        prepareDataRetention() {
            console.log('prepareDataRetention')
            this.form.has_retention = !_.isEmpty(this.form.retention)
            if (this.form.has_retention) {
                this.retention_query_data = {...this.form.retention}
            }
        },
        async prepareDataDetraction() {
            console.log('prepareDataDetraction')
            this.form.has_detraction = !_.isEmpty(this.form.detraction)
            if (this.form.has_detraction) {
                let legend_value = (this.form.operation_type_id === '1001') ? 'Operación sujeta a detracción' : 'Operación Sujeta a Detracción - Servicios de Transporte - Carga'
                let legend = await _.find(this.form.legends, {'code': '2006'})
                if (!legend) this.form.legends.push({code: '2006', value: legend_value})
            }
        },
        onPrepareAdditionalInformation(data) {
            console.log('onPrepareAdditionalInformation')
            let obs = null
            if (Array.isArray(data)) {
                if (data.length > 0) {
                    if (data[0] === '') {
                        return obs;
                    }
                }
                return data.join('|')
            }

            return data;
        },
        onPrepareItems(items) {
            console.log('onPrepareItems')
            return items.map(i => {
                if (this.table) {
                    if (this.table == 'quotations') {
                        i.unit_price_value = i.unit_value;
                        i.input_unit_price_value = (i.item.has_igv) ? i.unit_price : i.unit_value;
                    } else {
                        i.unit_price_value = i.unit_value;
                        i.input_unit_price_value = (i.item.has_igv) ? i.item.unit_price : i.unit_value;
                    }
                } else {
                    i.unit_price_value = i.unit_value;
                    i.input_unit_price_value = (i.item.has_igv) ? i.unit_price : i.unit_value;
                }
                i.discounts = (i.discounts) ? Object.values(i.discounts) : []
                i.charges = i.charges || [];
                i.attributes = i.attributes || [];
                i.item.id = i.item_id;
                i.additional_information = this.onPrepareAdditionalInformation(i.additional_information);
                i.item = this.onPrepareIndividualItem(i);
                return i;
            });
        },
        onPrepareIndividualItem(data) {
            console.log('onPrepareIndividualItem')
            let new_item = data.item
            let currency_type = _.find(this.currency_types, {'id': this.form.currency_type_id})

            new_item.currency_type_id = currency_type.id
            new_item.currency_type_symbol = currency_type.symbol
            new_item.sale_affectation_igv_type_id = data.affectation_igv_type_id

            if (this.table) {
                if (this.table === 'quotations') {
                    new_item.sale_unit_price = data.unit_price
                    new_item.unit_price = data.unit_price
                } else {
                    new_item.sale_unit_price = new_item.unit_price
                }
            } else {
                new_item.sale_unit_price = data.unit_price
                new_item.unit_price = data.unit_price
            }

            return new_item
        },
        onSetSeriesId(documentType, serie) {
            console.log('onSetSeriesId')
            const find = this.all_series.find(s => s.document_type_id === documentType && s.number === serie);
            if (find) {
                return find.id;
            }
            return null;
        },
        onSetSeries(documentType, serie) {
            console.log('onSetSeries')
            const find = this.all_series.find(s => s.document_type_id === documentType && s.number === serie);
            if (find) {
                return [find];
            }
            return [];
        },
        getPrepayment(index) {
            console.log('getPrepayment')
            return _.find(this.prepayment_documents, {id: this.form.prepayments[index].document_id})
        },
        inputAmountPrepayment(index) {
            console.log('inputAmountPrepayment')
            // let prepayment = this.getPrepayment(index)
            // if (parseFloat(this.form.prepayments[index].amount) > parseFloat(prepayment.amount)) {
            //     this.form.prepayments[index].amount = prepayment.amount
            //     this.$message.error('El monto debe ser menor o igual al del anticipo');
            // }
            // this.form.prepayments[index].total = (this.form.affectation_type_prepayment === '10') ? _.round(this.form.prepayments[index].amount * (1 + this.percentage_igv), 2) : this.form.prepayments[index].amount
            // this.changeTotalPrepayment()
        },
        selectDocumentType() {
            console.log('selectDocumentType')
            this.form.document_type_id = (this.select_first_document_type_03) ? '03' : '01'
        },
        keyupCustomer() {
            console.log('keyupCustomer')
            if (this.input_person.number) {
                if (!isNaN(parseInt(this.input_person.number))) {
                    switch (this.input_person.number.length) {
                        case 8:
                            this.input_person.identity_document_type_id = '1'
                            this.showDialogNewPerson = true
                            break;
                        case 11:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break;
                        default:
                            this.input_person.identity_document_type_id = '6'
                            this.showDialogNewPerson = true
                            break;
                    }
                }
            }
        },
        addDocumentDetraction(detraction) {
            console.log('addDocumentDetraction')
            this.form.detraction = Object.assign({}, this.form.detraction, detraction);
            this.form.has_detraction = (detraction) ? detraction.has_data_detraction : false
            this.changeDetractionType()
        },
        clickAddItemInvoice() {
            console.log('clickAddItemInvoice')
            this.recordItem = null
            this.showDialogAddItem = true
        },
        getFormatUnitPriceRow(unit_price) {
            console.log('getFormatUnitPriceRow')
            return _.round(unit_price, 6)
        },
        async changeDocumentPrepayment(index) {
            console.log('changeDocumentPrepayment')
            let prepayment = this.prepayment_documents.find(row => row.id === this.form.prepayments[index].document_id)
            this.form.prepayments[index].number = prepayment.number
            this.form.prepayments[index].document_type_id = prepayment.document_type_id
            this.form.prepayments[index].total_unaffected = prepayment.total_unaffected
            this.form.prepayments[index].total_exonerated = prepayment.total_exonerated
            this.form.prepayments[index].total_taxed = prepayment.total_taxed
            this.form.prepayments[index].total_igv = prepayment.total_igv
            this.form.prepayments[index].total = prepayment.total
            this.calculateTotal()
            // await this.changeTotalPrepayment()
        },
        clickAddPrepayment() {
            console.log('clickAddPrepayment')
            this.form.prepayments.push({
                document_id: null,
                number: null,
                document_type_id: null,
                total_igv: 0,
                total_taxed: 0,
                total_unaffected: 0,
                total_exonerated: 0,
                total: 0,
            })
            //this.calculateTotal()
        },
        clickRemovePrepayment(index) {
            console.log('clickRemovePrepayment')
            this.form.prepayments.splice(index, 1)
            this.calculateTotal()
            // this.changeTotalPrepayment()
            // if (this.form.prepayments.length === 0) {
            //     this.deletePrepaymentDiscount()
            // }
        },
        async changePrepaymentDeduction() {
            console.log('changePrepaymentDeduction')
            this.form.prepayments = []
            if (this.prepayment_deduction) {
                await this.initialValueATPrepayment()
                await this.getDocumentsPrepayment()
            } else {
                this.calculateTotal()
            }
            //this.calculateTotal()
            // this.form.prepayments = []
            // this.form.total_prepayment = 0
            // await this.deletePrepaymentDiscount()
            // if (this.prepayment_deduction) {
            // } else {
            //     this.cleanValueATPrepayment()
            // }
        },
        setPendingAmount() {
            console.log('setPendingAmount')
            this.form.pending_amount_prepayment = this.form.is_prepayment ? this.form.total : 0
        },
        initialValueATPrepayment() {
            console.log('initialValueATPrepayment')
            this.form.affectation_type_prepayment = (!this.form.affectation_type_prepayment) ? '10' : this.form.affectation_type_prepayment
        },
        cleanValueATPrepayment() {
            console.log('cleanValueATPrepayment')
            this.form.affectation_type_prepayment = null
        },
        changeHasPrepayment() {
            console.log('changeHasPrepayment')
            if (this.form.is_prepayment) {
                this.initialValueATPrepayment()
            } else {
                this.cleanValueATPrepayment()
            }
            this.setPendingAmount()
        },
        changeAffectationTypePrepayment() {
            console.log('changeAffectationTypePrepayment')
            // await this.initialValueATPrepayment()
            // if (this.prepayment_deduction) {
            //     this.form.total_prepayment = 0
            //     await this.deletePrepaymentDiscount()
            //     await this.changePrepaymentDeduction()
            // }
        },
        async deletePrepaymentDiscount() {
            console.log('deletePrepaymentDiscount')
            let discount = this.form.discounts.find(row => row.discount_type_id === '04')
            let discount_exonerated = this.form.discounts.find(row => row.discount_type_id === '05')
            let discount_unaffected = this.form.discounts.find(row => row.discount_type_id === '06')

            let pos = this.form.discounts.indexOf(discount)
            if (pos > -1) {
                this.form.discounts.splice(pos, 1)
                this.changeTotalPrepayment()
            }

            let pos_exonerated = this.form.discounts.indexOf(discount_exonerated)
            if (pos_exonerated > -1) {
                this.form.discounts.splice(pos_exonerated, 1)
                this.changeTotalPrepayment()
            }

            let pos_unaffected = this.form.discounts.indexOf(discount_unaffected)
            if (pos_unaffected > -1) {
                this.form.discounts.splice(pos_unaffected, 1)
                this.changeTotalPrepayment()
            }
        },
        async getDocumentsPrepayment(ids = null) {
            console.log('getDocumentsPrepayment')
            await this.$http.post(`/${this.resource}/prepayments2`, {
                'person_id': this.form.customer_id,
                'document_type_id': this.form.document_type_id,
                'ids': ids
            }).then((response) => {
                this.prepayment_documents = response.data
            })
        },
        changeTotalPrepayment() {
            console.log('changeTotalPrepayment')
            this.calculateTotal()
        },
        isActiveBussinessTurn(value) {
            console.log('isActiveBussinessTurn')
            // return (_.find(this.business_turns, {'value': value})) ? true : false
        },
        visibleDialogReportCustomer() {
            console.log('visibleDialogReportCustomer')
            this.report_to_customer_id = this.form.customer_id
            this.showDialogReportCustomer = true
        },
        clickAddDocumentHotel() {
            console.log('clickAddDocumentHotel')
            this.showDialogFormHotel = true
        },
        clickAddDocumentTransport() {
            console.log('clickAddDocumentTransport')
            this.showDialogFormTransport = true
        },
        addDocumentHotel(hotel) {
            console.log('addDocumentHotel')
            this.form.hotel = hotel
        },
        addDocumentTransport(transport) {
            console.log('addDocumentTransport')
            this.form.transport = transport
        },
        changeIsReceivable() {
            console.log('changeIsReceivable')

        },
        async ediItem(row, index) {
            console.log('ediItem')
            row.indexi = index
            this.recordItem = row
            this.showDialogAddItem = true
        },
        searchRemoteCustomers(input) {
            console.log('searchRemoteCustomers')
            if (input && input.length > 0) {
                this.loading_search = true
                let parameters = `input=${input}&document_type_id=${this.form.document_type_id}&operation_type_id=${this.form.operation_type_id}`

                this.$http.get(`/${this.resource}/search/customers?${parameters}`)
                    .then(response => {
                        this.customers = response.data.customers
                        this.loading_search = false
                        this.input_person.number = (this.customers.length == 0) ? input : null
                    })
            } else {
                this.filterCustomers()
                this.input_person.number = null
            }
        },
        changeRetention() {
            console.log('changeRetention')
            this.calculateDiscountGlobal()
            // this.calculateTotal()
            // this.calculateRetention()
            // this.getTotal()
        },
        calculateRetention() {
            console.log('calculateRetention')
            this.form.retention = {}
            this.form.total_retention = 0

            if (this.form.has_retention) {
                console.log('calculateRetention has retention')
                let exchange_rate_sale = parseFloat(this.form.exchange_rate_sale)
                let base = parseFloat(this.form.total)
                let percentage = _.round(parseFloat(this.config.igv_retention_percentage) / 100, 5)
                let amount = _.round(base * percentage, 2)

                let amount_pen = amount
                let amount_usd = _.round(amount / exchange_rate_sale, 2)
                if (this.form.currency_type_id === 'USD') {
                    amount_usd = amount
                    amount_pen = _.round(amount * exchange_rate_sale, 2)
                }
                this.form.retention = Object.assign({}, this.form.retention, {
                    base: base,
                    code: '62', //Código de Retención del IGV
                    amount: amount,
                    percentage: percentage,
                    currency_type_id: this.form.currency_type_id,
                    exchange_rate: exchange_rate_sale,
                    amount_pen: amount_pen,
                    amount_usd: amount_usd,
                });
                this.setDataVoucherRetention()
                this.form.total_retention = amount.toFixed(2)
            }
        },
        setDataVoucherRetention() {
            console.log('setDataVoucherRetention')
            if (this.isUpdateDocument && this.retention_query_data) {
                this.form.retention.voucher_date_of_issue = this.retention_query_data.voucher_date_of_issue
                this.form.retention.voucher_number = this.retention_query_data.voucher_number
                this.form.retention.voucher_amount = this.retention_query_data.voucher_amount
                this.form.retention.voucher_filename = this.retention_query_data.voucher_filename
            }
        },
        initInputPerson() {
            console.log('initInputPerson')
            this.input_person = {
                number: null,
                identity_document_type_id: null
            }
        },
        async changeOperationType(data) {
            console.log('changeOperationType')
            await this.filterCustomers()
            await this.setDataDetraction()
            let operationType = this.operation_types.find(row => row.id === this.form.operation_type_id)
            let items = []
            if (operationType.exportation) {
                this.form.items.forEach((row) => {
                    row.affectation_igv_type_id = '40'
                    row.affectation_igv_type_name = 'Exportación de bienes o servicios'
                    items.push(calculateRowItem(row, this.percentage_igv))
                })
            } else {
                this.form.items.forEach((row) => {
                    row.affectation_igv_type_id = row.affectation_igv_type_id_init
                    row.affectation_igv_type_name = row.affectation_igv_type.description
                    items.push(calculateRowItem(row, this.percentage_igv))
                })
            }
            this.form.items = items
            this.calculateTotal()
        },
        async setDataDetraction() {
            console.log('setDataDetraction')
            this.form.has_detraction = false
            if (this.form.operation_type_id === '1001') {
                this.showDialogDocumentDetraction = true
                let legend = await _.find(this.form.legends, {'code': '2006'})
                if (!legend) this.form.legends.push({code: '2006', value: 'Operación sujeta a detracción'})
                this.form.detraction = Object.assign({}, this.form.detraction, {
                    'bank_account': this.company.detraction_account
                });
            } else if (this.form.operation_type_id === '1004') {
                this.showDialogDocumentDetraction = true
                let legend = await _.find(this.form.legends, {'code': '2006'})
                if (!legend) this.form.legends.push({
                    code: '2006',
                    value: 'Operación Sujeta a Detracción - Servicios de Transporte - Carga'
                })
                this.form.detraction = Object.assign({}, this.form.detraction, {
                    'bank_account': this.company.detraction_account
                });
                this.form.has_detraction = true
                // this.form.detraction.bank_account = this.company.detraction_account
            } else {
                _.remove(this.form.legends, {'code': '2006'})
                this.form.detraction = null
                this.form.total_detraction = 0
            }
        },
        calculateDetraction() {
            console.log('calculateDetraction')
            this.form.total_detraction = 0;
            let total = parseFloat(this.form.total)
            if (this.form.has_detraction && total > 0) {
                let exchange_rate_sale = this.form.exchange_rate_sale
                let amount = 0
                let amount_pen = 0
                let amount_usd = 0

                if (this.form.currency_type_id === 'PEN') {
                    amount_pen = _.round(total * (parseFloat(this.form.detraction.percentage) / 100), this.detractionDecimalQuantity)
                    amount_usd = _.round(amount_pen / exchange_rate_sale, this.detractionDecimalQuantity)
                    amount = amount_pen
                    this.form.total_detraction = amount.toFixed(2)
                } else {
                    amount_usd = _.round(total * (parseFloat(this.form.detraction.percentage) / 100), this.detractionDecimalQuantity)
                    amount_pen = _.round(amount_usd * exchange_rate_sale, this.detractionDecimalQuantity)
                    amount = amount_usd
                    this.form.total_detraction = amount_usd.toFixed(2)
                }
                this.form.detraction = Object.assign({}, this.form.detraction, {
                    'amount': amount,
                    'amount_pen': amount_pen,
                    'amount_usd': amount_usd,
                });
            }
        },
        async changeDetractionType() {
            console.log('changeDetractionType')
            this.calculateDetraction()
            this.getTotal()
        },
        validateDetraction() {
            console.log('validateDetraction')
            if (['1001', '1004'].includes(this.form.operation_type_id)) {
                let detraction = this.form.detraction
                let tot = (this.form.currency_type_id === 'PEN') ? this.form.total : (this.form.total * this.form.exchange_rate_sale)
                let total_restriction = (this.form.operation_type_id === '1001') ? detraction.detraction_type_id == '010' ? 0.1 : 700 : 400
                if (tot <= total_restriction)
                    return {
                        success: false,
                        message: `El importe de la operación debe ser mayor a S/ ${total_restriction}.00 o equivalente en USD`
                    }
                if (!detraction.detraction_type_id)
                    return {success: false, message: 'El campo bien o servicio sujeto a detracción es obligatorio'}
                if (!detraction.payment_method_id)
                    return {success: false, message: 'El campo método de pago - detracción es obligatorio'}
                if (!detraction.bank_account)
                    return {success: false, message: 'El campo cuenta bancaria es obligatorio'}
                if (detraction.amount <= 0)
                    return {success: false, message: 'El campo total detracción debe ser mayor a cero'}
            }

            return {success: true}
        },
        // changeEstablishment() {
        //     console.log('changeEstablishment')
        //     this.form.number = '#'
        //     this.establishment = this.establishments.find(row => row.id === this.form.establishment_id)
        //     this.filterSeries()
        //     this.selectDefaultCustomer()
        // },
        async selectDefaultCustomer() {
            console.log('selectDefaultCustomer')
            // console.log(this.establishment)
            if (this.establishment.customer_id) {
                // let temp_all_customers = this.all_customers
                // let temp_customers = this.customers
                const customer = this.all_customers.find(row => row.id === this.establishment.customer_id)
                if (!customer) {
                    await this.$http.get(`/${this.resource}/search/customer/${this.establishment.customer_id}`)
                        .then((response) => {
                            let data_customer = response.data.customers
                            this.all_customers.push(...data_customer)
                            this.customers.push(...data_customer)
                        })
                }

                // temp_all_customers = this.all_customers.filter((item, index, self) =>
                //         index === self.findIndex((t) => (
                //             t.id === item.id
                //         ))
                // )
                // temp_customers = this.customers.filter((item, index, self) =>
                //         index === self.findIndex((t) => (
                //             t.id === item.id
                //         ))
                // )
                // this.all_customers = temp_all_customers;
                // this.customers = temp_customers;
                await this.filterCustomers()
                let alt = this.customers.find(row => row.id === this.establishment.customer_id)
                if (alt !== undefined) {
                    this.form.customer_id = this.establishment.customer_id
                    this.validateCustomerRetention(alt.identity_document_type_id)
                    let seller = this.sellers.find(element => element.id === alt.seller_id)
                    if (seller !== undefined) {
                        this.form.seller_id = seller.id
                    }
                    await this.setCustomerAccumulatedPoints(alt.id, this.config.enabled_point_system)
                }
            }
        },
        changeDocumentType() {
            console.log('changeDocumentType')
            this.filterSeries()
            this.cleanCustomer()
            this.filterCustomers()
        },
        cleanCustomer() {
            console.log('cleanCustomer')
            this.form.customer_id = null
        },
        dateValidError() {
            console.log('dateValidError')
            this.$message.error(`No puede seleccionar una fecha menor a ${this.configuration.shipping_time_days} día(s).`);
            // this.$message.error('No puede seleccionar una fecha menor a 6 días.');
            this.dateValid = false
        },
        validateDateOfIssue() {
            console.log('validateDateOfIssue')
            let minDate = moment().subtract(this.configuration.shipping_time_days, 'days')
            // let minDate = moment().subtract(7, 'days')

            // validar fecha de factura sin considerar configuracion
            if (moment(this.form.date_of_issue) < minDate && this.form.document_type_id === '01') {

                this.dateValidError()
            } else if (moment(this.form.date_of_issue) < minDate && this.config.restrict_receipt_date) {

                this.dateValidError()

            } else {
                this.dateValid = true
            }

        },
        async changeDateOfIssue() {
            console.log('changeDateOfIssue')
            this.validateDateOfIssue()
            this.form.date_of_due = this.form.date_of_issue
            await this.searchExchangeRateByDate(this.form.date_of_issue).then(response => {
                this.form.exchange_rate_sale = response
            });
            await this.getPercentageIgv();
            this.changeCurrencyType();
            this.changePaymentCondition();
        },
        assignmentDateOfPayment() {
            console.log('assignmentDateOfPayment')
            this.form.payments.forEach((payment) => {
                payment.date_of_payment = this.form.date_of_issue
            })
        },
        filterSeries() {
            console.log('filterSeries')
            this.form.series = null
            this.series = this.all_series.filter(row => {
                return row.document_type_id === this.form.document_type_id && row.contingency === this.is_contingency
            })
            let user_series = null
            if (this.user_series.length > 0) {
                user_series = this.user_series.find(row => {
                    return row.document_type_id === this.form.document_type_id
                })
            }
            if (user_series) {
                let series = this.series.find(row => {
                    return row.id === user_series.series_id
                })
                if (series) {
                    this.form.series = series.number
                    return;
                }
            }

            this.form.series = (this.series.length > 0) ? this.series[0].number : null
        },
        filterCustomers() {
            console.log('filterCustomers')
            if (['0101', '1001', '1004'].includes(this.form.operation_type_id)) {
                if (this.form.document_type_id === '01') {
                    if (!_.isNull(this.form.customer_id)) {
                        const cus = _.find(this.all_customers, {'id': this.form.customer_id});
                        if (cus && cus.identity_document_type_id !== '6') {
                            this.form.customer_id = null
                        }
                    }
                    this.customers = _.filter(this.all_customers, {'identity_document_type_id': '6'})
                } else {
                    if (this.document_type_03_filter) {
                        this.customers = _.filter(this.all_customers, (c) => {
                            return c.identity_document_type_id !== '6'
                        })
                    } else {
                        this.customers = this.all_customers
                    }
                }
            } else {
                this.customers = this.all_customers
            }
        },
        clickAddInitGuides() {
            console.log('clickAddInitGuides')
            this.form.guides.push({
                document_type_id: '09',
                number: null
            }, {
                document_type_id: '31',
                number: null
            })
        },
        clickAddGuide() {
            console.log('clickAddGuide')
            this.form.guides.push({
                document_type_id: null,
                number: null
            })
        },
        clickRemoveGuide(index) {
            console.log('clickRemoveGuide')
            this.form.guides.splice(index, 1)
        },
        addRow(row) {
            console.log('addRow')
            if (this.recordItem) {
                this.form.items[this.recordItem.indexi] = row
                this.recordItem = null
                if (this.config.enabled_point_system) {
                    this.setTotalExchangePoints()
                    this.recalculateUsedPointsForExchange(row)
                }
            } else {
                this.form.items.push(JSON.parse(JSON.stringify(row)));
            }

            this.calculateTotal();
        },
        clickRemoveItem(index) {
            console.log('clickRemoveItem')
            this.form.items.splice(index, 1)
            this.calculateTotal()

            if (this.config.enabled_point_system) this.setTotalExchangePoints()
        },
        changeCurrencyType() {
            console.log('changeCurrencyType')
            this.currency_type = _.find(this.currency_types, {'id': this.form.currency_type_id})
            let items = []
            this.form.items.forEach((row) => {
                if (row.currency_type_id === 'PEN' && this.form.currency_type_id === 'USD') {
                    row.unit_price = row.unit_price / this.form.exchange_rate_sale
                }
                if (row.currency_type_id === 'USD' && this.form.currency_type_id === 'PEN') {
                    row.unit_price = row.unit_price * this.form.exchange_rate_sale
                }
                row.currency_type_id = this.form.currency_type_id
                items.push(calculateRowItem(row, this.percentage_igv))
            })
            this.form.items = items
            this.calculateTotal()
        },


        // allCustomers() {
        //     if(this.form.document_type_id === '01') {
        //         this.customers = this.all_customers.filter(row => {
        //             return row.identity_document_type_id === '6'
        //         })
        //     } else {
        //         this.customers = this.all_customers
        //     }
        // },
        calculateTotal() {
            console.log('calculateTotal')
            this.form = Object.assign({}, this.form, fCalculateTotal(this.form))
            this.calculateDiscountGlobal()
        },
        chargeGlobal() {
            console.log('chargeGlobal')
            let base = parseFloat(this.form.total)
            if (this.config.active_allowance_charge) {
                let percentage_allowance_charge = parseFloat(this.config.percentage_allowance_charge)
                this.total_global_charge = _.round(base * (percentage_allowance_charge / 100), 2)
            }
            if (this.total_global_charge === 0) {
                this.deleteChargeGlobal()
                return
            }
            let amount = parseFloat(this.total_global_charge)
            let factor = _.round(amount / base, 5)
            let charge = _.find(this.form.charges, {charge_type_id: '50'})
            if (amount > 0 && !charge) {
                this.form.total_charge = _.round(amount, 2)
                this.form.total = _.round(this.form.total + this.form.total_charge, 2)
                this.form.charges.push({
                    charge_type_id: '50',
                    description: 'Cargos globales que no afectan la base imponible del IGV/IVAP',
                    factor: factor,
                    amount: amount,
                    base: base
                })
            } else {
                let pos = this.form.charges.indexOf(charge);
                if (pos > -1) {
                    this.form.total_charge = _.round(amount, 2)
                    this.form.total = _.round(this.form.total + this.form.total_charge, 2)
                    this.form.charges[pos].base = base
                    this.form.charges[pos].amount = amount
                    this.form.charges[pos].factor = factor
                }
            }
        },
        deleteChargeGlobal() {
            console.log('deleteChargeGlobal')
            let charge = _.find(this.form.charges, {charge_type_id: '50'})
            let index = this.form.charges.indexOf(charge)
            if (index > -1) {
                this.form.charges.splice(index, 1)
                this.form.total_charge = 0
            }
        },
        changeTypeDiscount() {
            console.log('changeTypeDiscount')
            this.calculateTotal()
        },
        changeTotalGlobalDiscount() {
            console.log('changeTotalGlobalDiscount')
            this.calculateTotal()
        },
        setConfigGlobalDiscountType() {
            console.log('setConfigGlobalDiscountType')
            this.global_discount_type = _.find(this.global_discount_types, {id: this.configuration.global_discount_type_id})
        },
        setGlobalDiscount(factor, amount, base) {
            console.log('setGlobalDiscount')
            this.form.discounts.push({
                discount_type_id: this.global_discount_type.id,
                description: this.global_discount_type.description,
                factor: factor,
                amount: amount,
                base: base,
                is_amount: this.is_amount
            })
        },
        calculateDiscountGlobal() {
            console.log('calculateDiscountGlobal')
            this.form = Object.assign({}, this.form,
                fCalculateDiscountGlobal(this.form, this.enabled_discount_global, this.discount_global_type, this.discount_global_amount))

            if (this.form.prepayments.length > 0) {
                this.form = Object.assign({}, this.form, fCalculateDiscountGlobalPrepayment(this.form))
            }

            this.calculateDetraction()
            this.calculateRetention()
            this.setTotalPointsBySale(this.config)
            this.getTotal()
        },
        async deleteInitGuides() {
            console.log('deleteInitGuides')
            await _.remove(this.form.guides, {'number': null})
        },
        async assignPlateNumberToItems() {
            console.log('assignPlateNumberToItems')
            if (this.form.plate_number !== null && this.form.plate_number !== '') {
                await this.form.items.forEach(item => {
                    let at = item.attributes.find(row => row.attribute_type_id === '5010')
                    if (!at) {
                        item.attributes.push({
                            attribute_type_id: '5010',
                            description: "Numero de Placa",
                            value: this.form.plate_number,
                            start_date: null,
                            end_date: null,
                            duration: null,
                        })
                    } else {
                        at.value = this.form.plate_number
                    }
                });
            }
        },
        async validateAffectationTypePrepayment() {
            console.log('validateAffectationTypePrepayment')
            // let affectation_type_10 = 0
            // let affectation_type_20 = 0
            // await this.form.items.forEach(item => {
            //     if (item.affectation_igv_type_id !== this.form.affectation_type_prepayment) {
            //         not_equal_affectation_type++
            //     }
            // });
            //
            // return {
            //     success: (not_equal_affectation_type <= 0),
            //     message: 'Los items deben tener tipo de afectación igual al seleccionado en el anticipo'
            // }
        },
        validatePaymentDestination() {
            console.log('validatePaymentDestination')
            let error_by_item = 0
            this.form.payments.forEach((item) => {
                if (!['05', '08', '09'].includes(item.payment_method_type_id)) {
                    if (item.payment_destination_id == null) error_by_item++;
                }
            })
            return {
                error_by_item: error_by_item,
            }
        },
        async submit() {
            console.log('submit')
            if (this.is_contingency && this.establishment.contingencia_manual_nuber) {
                if (this.form.number === '#') {
                    this.$message.error('Tiene activo serie manual en CPE de contingencia, por favor, asigne un número');
                    return false;
                }
            }

            if (this.form.show_terms_condition) {
                this.form.terms_condition = this.config.terms_condition_sale;
            }

            if (this.form.id === null) {
                if (this.form.payment_condition_id === '01') {
                    this.form.fee = []
                } else if (this.form.payment_condition_id === '02') {
                    this.form.payments = []
                } else {
                    this.form.fee = []
                    this.form.payments = []
                }
            }

            if (this.form.payment_condition_id === '01') {
                if (this.form.payments.length === 0) {
                    return this.$message.error('El registro de pagos es obligatorio');
                }
            }

            if (this.form.payment_condition_id === '02') {
                if (this.form.fee.length === 0) {
                    return this.$message.error('El registro de cuotas es obligatorio');
                }
                this.form.date_of_due = this.form.fee[this.form.fee.length - 1].date
            }

            if (!['01', '02'].includes(this.form.payment_condition_id)) {
                this.form.fee = [];
                this.form.fee.push({
                    id: null,
                    document_id: null,
                    payment_method_type_id: null,
                    date: this.form.date_of_due,
                    currency_type_id: this.form.currency_type_id,
                    amount: this.form.total_payment,
                });
            }

            // if (this.is_receivable) {
            //     this.form.payments = []
            // } else {
            //     let validate = await this.validate_payments()
            //     if (validate.acum_total > parseFloat(this.form.total) || validate.error_by_item > 0) {
            //         return this.$message.error('Los montos ingresados superan al monto a pagar o son incorrectos');
            //     }
            //     let validate_payment_destination = await this.validatePaymentDestination()
            //     if (validate_payment_destination.error_by_item > 0) {
            //         return this.$message.error('El destino del pago es obligatorio');
            //     }
            // }
            await this.deleteInitGuides()
            await this.assignPlateNumberToItems()
            let val_detraction = await this.validateDetraction()
            if (!val_detraction.success)
                return this.$message.error(val_detraction.message);

            if (!this.enabled_payments) {
                this.form.payments = []
            }
            // validacion sistema por puntos
            if (this.config.enabled_point_system) {
                const validate_exchange_points = this.validateExchangePoints()
                if (!validate_exchange_points.success) return this.$message.error(validate_exchange_points.message)
            }
            // validacion sistema por puntos

            if (this.isGeneratedFromExternal) {
                // validacion restriccion de productos
                const validate_restrict_sale_items_cpe = this.fnValidateRestrictSaleItemsCpe(this.form)
                if (!validate_restrict_sale_items_cpe.success) return this.$message.error(validate_restrict_sale_items_cpe.message)
            }

            let path = `/${this.resource}`;
            if (this.form.id) {
                path = `/${this.resource}/${this.form.id}/update`;
            }
            let temp = this.form.payment_condition_id;
            // Condicion de pago Credito con cuota pasa a credito
            //if (this.form.payment_condition_id === '03') this.form.payment_condition_id = '02';
            this.loading_submit = true
            await this.$http.post(path, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.resetForm()
                        this.recordData = response.data.data
                        this.documentNewId = response.data.data.id
                        this.showDialogOptions = true
                        this.autoPrintDocument()
                    } else {
                        this.$message.error(response.data.message)
                    }
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        this.$message.error(error.response.data.message)
                    }
                    if (temp === '03') this.form.payment_condition_id = '03'
                }).finally(() => {
                    // this.setDefaultDocumentType()
                    this.loading_submit = false
                })
        },
        showOptionsDialog(response) {
            console.log('showOptionsDialog')
            if (this.hidePreviewPdf) {
                const response_data = response.data.data
                if (response_data.response.sent) {
                    this.$message.success(response_data.response.description)
                } else {
                    this.$message.success(`Comprobante registrado: ${response_data.number_full}`)
                }
            } else {
                this.showDialogOptions = true
            }
        },
        autoPrintDocument() {
            console.log('autoPrintDocument')
            if (this.isAutoPrint) {
                this.$http.get(`/printticket/document/${this.documentNewId}/ticket`)
                    .then(response => {
                        this.printTicket(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },
        printTicket(html_pdf) {
            console.log('printTicket')
            if (html_pdf.length > 0) {
                const config = getUpdatedConfig()
                const opts = getUpdatedConfig()
                const printData = [
                    {
                        type: 'html',
                        format: 'plain',
                        data: html_pdf,
                        options: opts
                    }
                ]
                qz.print(config, printData)
                    .then(() => {

                        this.$notify({
                            title: '',
                            message: 'Impresión en proceso...',
                            type: 'success'
                        })

                    })
                    .catch(displayError)
            }
        },
        saveCashDocument() {
            console.log('saveCashDocument')
            this.$http.post(`/cash/cash_document`, this.form_cash_document)
                .then(response => {
                    if (!response.data.success) {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => console.log(error))
        },
        validate_payments() {
            console.log('validate_payments')

            //eliminando items de pagos
            for (let index = 0; index < this.form.payments.length; index++) {
                if (parseFloat(this.form.payments[index].payment) === 0)
                    this.form.payments.splice(index, 1)
            }

            let error_by_item = 0
            let acum_total = 0

            this.form.payments.forEach((item) => {
                acum_total += parseFloat(item.payment)
                if (item.payment <= 0 || item.payment == null) error_by_item++;
            })

            return {
                error_by_item: error_by_item,
                acum_total: acum_total
            }

        },
        close() {
            console.log('close')
            if (this.table) {
                if (this.table === 'sale_notes') {
                    location.href = `/sale-notes`
                } else if (this.table === 'order_notes') {
                    location.href = `/order-notes`
                } else {
                    location.href = `/${this.table}`
                }
            } else {
                location.href = (this.is_contingency) ? `/contingencies` : `/${this.resource}`
            }
        },
        async reloadDataCustomers(customer_id) {
            console.log('reloadDataCustomers')
            await this.$http.get(`/${this.resource}/search/customer/${customer_id}`).then((response) => {
                this.customers = response.data.customers
                this.form.customer_id = customer_id

                this.setCustomerAccumulatedPoints(customer_id, this.config.enabled_point_system)

            })
        },
        changeCustomer() {
            console.log('changeCustomer')
            this.customer_addresses = [];
            this.form.customer_address_id = null;
            let customer = _.find(this.customers, {'id': this.form.customer_id});
            this.customer_addresses = customer.addresses;
            if (customer.address) {
                this.customer_addresses.unshift({
                    id: null,
                    address: customer.address,
                    location_id: customer.location_id
                })
            }
            this.form.has_retention = customer.is_agent_retention
            this.changeRetention();
            this.setCustomerAccumulatedPoints(customer.id, this.config.enabled_point_system)
            let seller = this.sellers.find(element => element.id == customer.seller_id)
            if (seller !== undefined) {
                this.form.seller_id = seller.id

            }
            // retencion para clientes con ruc
            this.validateCustomerRetention(customer.identity_document_type_id)
            this.is_amount = "01"
            this.total_global_discount = 0
            if (customer.has_discount_type === '01') {
                this.is_amount = customer.discount_type
                this.total_global_discount = customer.discount_amount
            }
            this.changeTypeDiscount()

            /*if(this.customer_addresses.length > 0) {
                let address = _.find(this.customer_addresses, {'main' : 1});
                this.form.customer_address_id = address.id;
            }*/
        },
        validateCustomerRetention(identity_document_type_id) {
            console.log('validateCustomerRetention')
            if (identity_document_type_id !== '6') {
                if (this.form.has_retention) {
                    this.form.has_retention = false
                    this.changeRetention()
                }
                this.show_has_retention = false
            } else {
                this.show_has_retention = true
            }
        },
        initDataPaymentCondition01() {
            console.log('initDataPaymentCondition01')
            this.readonly_date_of_due = false
            this.enabled_payments = true
            this.form.date_of_due = this.form.date_of_issue
            this.form.payment_method_type_id = null
        },
        changePaymentCondition() {
            console.log('changePaymentCondition')
            // this.form.fee = [];
            // this.form.payments = [];
            if (!['01', '02'].includes(this.form.payment_condition_id)) {
                let pc = _.find(this.payment_conditions, {'id': this.form.payment_condition_id});
                this.form.date_of_due = moment(this.form.date_of_issue).add(pc.days, 'days').format('YYYY-MM-DD');
            } else {
                this.form.date_of_due = moment(this.form.date_of_issue).format('YYYY-MM-DD');
            }
        },
        getTotal() {
            console.log('getTotal')
            let total = parseFloat(this.form.total)
            let total_retention = parseFloat(this.form.total_retention)
            let total_detraction = parseFloat(this.form.total_detraction)

            this.form.total_payment = _.round(total - total_retention - total_detraction, 2).toFixed(2)
        },
        changeAmountDetraction() {
            console.log('changeAmountDetraction')
            this.form.detraction.amount = this.form.total_detraction
            this.getTotal()
            this.changeDetractionTypeManual()
        },
        async changeDetractionTypeManual() {
            console.log('changeDetractionTypeManual')
            if (this.form.detraction) {
                let exchange_rate_sale = parseFloat(this.form.exchange_rate_sale)
                let amount = 0
                let amount_pen = 0
                let amount_usd = 0

                if (this.form.currency_type_id === 'PEN') {
                    amount_pen = parseFloat(this.form.total_detraction)
                    amount_usd = _.round(amount_pen / exchange_rate_sale, this.detractionDecimalQuantity)
                    amount = amount_pen
                    this.form.total_detraction = amount.toFixed(2)
                    this.form.detraction.amount_pen = amount_pen
                    this.form.detraction.amount_usd = amount_usd
                } else {
                    amount_usd = parseFloat(this.form.total_detraction)
                    amount_pen = _.round(amount_usd * exchange_rate_sale, this.detractionDecimalQuantity)
                    amount = amount_usd
                    this.form.total_detraction = amount_usd.toFixed(2)
                    this.form.detraction.amount_pen = amount_pen
                    this.form.detraction.amount_usd = amount_usd
                }
                this.form.detraction = Object.assign({}, this.form.detraction, {
                    'amount': amount,
                    'amount_pen': amount_pen,
                    'amount_usd': amount_usd,
                })
            }
        },
        setDescriptionOfItem(row) {
            console.log('setDescriptionOfItem')
            return showNamePdfOfDescription2(row, this.config.show_pdf_name)
        },
        checkKeyWithAlt(e) {
            console.log('checkKeyWithAlt')
            let code = e.event.code;
            if (
                this.showDialogOptions === true &&
                code === 'KeyN'
            ) {
                this.showDialogOptions = false
            }

            if (
                code === 'KeyG'  // key G
                && !this.showDialogAddItem   // Modal hidden
                && this.form.items.length > 0  // with items
                && this.focus_on_client === false // not client search
            ) {
                this.submit()
            }
        },
        checkKey(e) {
            console.log('checkKey')
            let code = e.event.code;
            if (code === 'F2') {
                //abrir el modal de agergar producto
                if (!this.showDialogAddItem) this.showDialogAddItem = true
            }
            if (code === 'Escape') {
                if (this.showDialogAddItem) this.showDialogAddItem = false
            }
        },
        openDialogLots(item) {
            console.log('openDialogLots')
            this.recordItem = item;
            this.showDialogItemSeriesIndex = true;
        },
        successItemSeries(series) {
            console.log('successItemSeries')
            let itemIndex = _.findIndex(this.form.items, {'item_id': this.recordItem.item_id});
            this.form.items[itemIndex].item.lots = series;
        },
        showItemSeries(series) {
            console.log('showItemSeries')
            return series.map(o => o['series']).join(', ');
        },
        successStoreDocuments(items) {
            console.log('successStoreDocuments')
            _.forEach(items, it => {
                this.addRow(it)
            })
        },
        preSubmit() {
            console.log('preSubmit')
            let operationType = this.operation_types.find(row => row.id === this.form.operation_type_id)
            if(operationType.exportation) {
                let person = this.customers.find(row => row.id === this.form.customer_id)
                if(person.identity_document_type_id !== '0') {
                    this.$message.error('El tipo de documento de identidad del cliente no esta permitido para este tipo de operación')
                    return;
                }
            }

            if (this.form.operation_type_id === '0202') {
                let error = false
                let messages = []
                this.form.items.forEach(it => {
                    if (!it.hasOwnProperty("accommodation_attributes") || it.accommodation_attributes === null) {
                        error = true
                        messages.push('Es requerido agregar los datos del huésped en cada servicio')
                    }
                    if (it.affectation_igv_type_id !== '40') {
                        error = true
                        messages.push('El tipo de afectación de igv de los servicios debe ser Exportación, debido al tipo de operación seleccionada')
                    }
                })
                if (error) {
                    messages.forEach(m => {
                        this.$message.error(m);
                    })
                    return false
                }
            }

            if(this.prepayment_deduction && this.form.prepayments.length === 0) {
                this.$message.error('Debe seleccionar al menos un anticipo')
                return;
            }

            if (this.form.prepayments.length > 0) {
                const map = new Map()
                let hasPrepaymentDuplicates = false
                let errorPrepayment = ''
                this.form.prepayments.forEach(row => {
                    if (row.document_id === null || row.document_id === undefined) {
                        errorPrepayment = 'Es requerido seleccionar un anticipo';
                        return; // Detenemos la iteración para este elemento
                    }
                    if (map.has(row.document_id)) {
                        hasPrepaymentDuplicates = true;
                    } else {
                        map.set(row.document_id, true);
                    }
                })
                if (errorPrepayment !== '') {
                    this.$message.error('Es requerido seleccionar un anticipo')
                    return
                }
                if (hasPrepaymentDuplicates) {
                    this.$message.error('No se puede seleccionar el mismo anticipo')
                    return
                }
            }

            if (this.form.payment_condition_id === '01') {
                this.showDialogDocumentPayments = true
                return
            }
            if (this.form.payment_condition_id === '02') {
                this.showDialogDocumentFee = true
                return
            }
            this.submit()
        },
        async successDocumentPayments(data) {
            console.log('successDocumentPayments')
            this.showDialogDocumentPayments = false
            this.form.payments = data
            await this.submit()
        },
        async successDocumentFee(data) {
            console.log('successDocumentFee')
            this.showDialogDocumentFee = false
            this.form.fee = data
            await this.submit()
        },
        warehouseSeleted(warehouses, warehouse_id) {
            console.log('warehouseSeleted')
            if (warehouses != undefined) {
                var warehouseSeleted = warehouses.filter(row => {
                    return row.warehouse_id == warehouse_id
                })
                return warehouseSeleted[0].warehouse_description
            }
        },
        registerLabel() {
            console.log('registerLabel')
            let person = _.find(this.customers, {'id': this.form.customer_id})
            let person_address = _.find(this.customer_addresses, {'id': this.form.customer_address_id})
            if (this.form.label) {
                this.formLabel = Object.assign({}, this.formLabel, this.form.label)
            } else {
                if (person_address) {
                    this.formLabel = Object.assign({}, this.formLabel, {
                        'address': person_address.address,
                        'location_id': person_address.location_id,
                        'address_reference': person.address_reference,
                        'cellphone_number': person.telephone,
                    });
                } else {
                    this.formLabel = Object.assign({}, this.formLabel, {
                        'address': person.address,
                        'location_id': person.location_id,
                        'address_reference': person.address_reference,
                        'cellphone_number': person.telephone,
                    })
                }
            }
            this.showDialogLabel = true

        },
        successRegisterLabel(data) {
            console.log('successRegisterLabel')
            this.form.label = Object.assign({}, this.form.label, data)
            this.showDialogLabel = false
        },
        changeDiscountGlobalType() {
            console.log('changeDiscountGlobalType')
            this.calculateDiscountGlobal()
        },
        clickAddAccommodationAttribute(row, index) {
            row.indexi = index
            this.recordItem = row
            // console.log('clickAddAccommodationAttribute')
            this.showDialogAccommodationAttribute = true
        },
        successRegisterAccommodationAttribute(data) {
            console.log('successRegisterAccommodationAttribute')
            this.form.items[this.recordItem.indexi].accommodation_attributes =
                Object.assign({}, this.form.items[this.recordItem.indexi].accommodation_attributes, data)
            this.showDialogAccommodationAttribute = false
        },
        successPerson(data) {
            this.form.customer_id = data.id
            this.customers = data.data
            this.changeCustomer()
        }
    }
}
</script>
